export const GET_ALL_CART_PRODUCTS = 'GET_ALL_CART_PRODUCTS'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const RESPONSE_STATUS2 = 'RESPONSE_STATUS2'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
